module.exports = __webpack_public_path__ + "files/a157f3cdd8c94f1f59d16cec520ead01.png";